import { useQuery } from "@tanstack/react-query";

import { consentDocumentsToSignQueryOptionsFactory } from "~/patients/factories/consentDocumentsToSignQueryOptionsFactory";
import { ListConsentDocumentToSignResponse } from "~/patients/types/consentDocuments";
import { useGetCurrentPatient } from "./queries";

export const useListConsentDocumentsToSign = (organizationId?: string) => {
  const { data: currentPatient } = useGetCurrentPatient();
  const hasSignedConsents = Boolean(
    currentPatient?.organization_patients[0].consent_signed_at,
  );

  return useQuery<ListConsentDocumentToSignResponse[]>({
    ...consentDocumentsToSignQueryOptionsFactory.list({ organizationId }),
    enabled: Boolean(organizationId) && !hasSignedConsents,
  });
};
